import PropTypes from 'prop-types'

import { Button } from '@/components/elements/button'
import {
  Dialog,
  DialogContent,
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/elements/dialog'

const ConfirmButton = ({ confirmContent, confirmTitle, onClick, loading = false, ...rest }) => (
  <Dialog>
    <DialogTrigger asChild>
      <Button {...rest} />
    </DialogTrigger>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{confirmTitle}</DialogTitle>
        <DialogDescription>{confirmContent}</DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <DialogClose asChild>
          <Button loading={loading} type="button" variant="secondary">
            Cancel
          </Button>
        </DialogClose>
        <DialogClose asChild>
          <Button loading={loading} type="button" onClick={onClick}>
            Confirm
          </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
)

ConfirmButton.propTypes = {
  confirmContent: PropTypes.string.isRequired,
  confirmTitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

export default ConfirmButton
